import { useContext } from 'react';
import { ImageAndLabelWrapper, Image, Label } from './styles';
import { ImageContext } from '../../context/ImageContext';

const MainImageEdit = ({ image, imageIndex, hideLabel, style }) => {
  const { idCardImages, setIdCardImages, onSuccessImageUpload, onSuccessImageRemove, shouldSendDeleteImageReq } =
    useContext(ImageContext);
  const handleImageTitleChange = (event) => {
    const updatedImages = [...idCardImages];
    updatedImages[imageIndex].legend = event.target.value;
    setIdCardImages(updatedImages);
  };

  return (
    <ImageAndLabelWrapper style={style}>
      <Image
        imageId={image.imageId}
        imageArrIndex={imageIndex}
        onImageUpload={onSuccessImageUpload}
        onImageRemove={onSuccessImageRemove}
        shouldSendDeleteImageReq={shouldSendDeleteImageReq}
      />

      {!hideLabel &&
      <Label
        value={image.legend}
        name={'imageTitle'}
        placeholder='Label / Title'
        onChange={handleImageTitleChange}
        type='text'
      />
      }
    </ImageAndLabelWrapper>
  );
};

export default MainImageEdit;
